<div class="wrapper">
  <main>
    <h1>404</h1>
    <div class="small-description">
      Страница Не Найдена
    </div>
    <div class="description">
      Страница, которую вы ищете, не существует
    </div>
    <button
      mat-stroked-button
      color="primary"
      (click)="goToHomePage()"
    >
      Вернуться на главную страницу
    </button>
  </main>
</div>

